import { api } from "./api"

export const GET_ALL_PROFILES = async () => {
    const {data} = await api.get("/profiles")
    return data.profiles || [];
}
